// This file is imported in all theme.liquid pages (most of Shopify pages uses theme.liquid).
import {renderStructuredElements} from "@/utils/render-helpers.jsx";
import CartQty from "@/components/CartQty";

document.addEventListener("DOMContentLoaded", () => {
  renderStructuredElements("cart-qty", CartQty);
});
